<template>
  <section>
    <v-row>
      <v-col>
        <v-data-table
          @pagination="fetchTableData()"
          :options.sync="table.options"
          :loading="table.isLoading"
          :headers="table.headers"
          :items="table.items"
          no-data-text="Nenhum log encotrado"
          :footer-props="{
            'items-per-page-text': 'LOG por Página',
            'items-per-page-options': [5, 10, 25, 50, 100, -1],
          }"
        >
          <template #top>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  label="Nome do usuário"
                  outlined
                  dense
                  v-model="table.search.name"
                  class="border__radius-15"
                  append-icon="mdi-magnify"
                  @click:append="fetchTableData"
                  @keydown.enter="fetchTableData"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  label="Perfil"
                  v-model="table.search.profile"
                  outlined
                  dense
                  class="border__radius-15"
                  append-icon="mdi-magnify"
                  @click:append="fetchTableData"
                  @keydown.enter="fetchTableData"
                />
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>    
  </section>
</template>

<script>
import axios from "@/axios";
export default {
    data: () => ({
        newSearch: false,

        table:{
            // devem ser inseridos as nomeclaturas de colunas no array logs como de acordo com o vuetify2
            headers: [
                { text: "Data e Hora", value: "dateTime" },
                { text: "Logs", value: "message" },
            ],
            // itens devem ser atualizados no método fetchTableData como já criado na função comentada
            items: [],
            // campos text que farão a pesquisa de logs
            search:{
                name: '',
                profile: '',
            },
            // loading... É um loading
            isLoading: false,            
            // informações que virão do meta resultado da requisição fetchTableData
            paginationData: {},
            // informações referentes a opções da tabela
            options:{
                page: 1,
                itemsPerPage: 10, 
            }

        }
    }),

    watch:{
        // verificação de modificação no valor da pesquisa para poder regredir a pagina da tabela para 1
        'table.search.name'(before, after){
            if(before != after)this.newSearch = true
        },
        'table.search.profile'(before, after){
            if(before != after)this.newSearch = true
        }
    },

    methods:{
        fetchTableData(){
            this.newSearch = false
            this.table.isLoading = true

            if(this.newSearch)this.table.options.page = 1
            axios.get('/logs/formatted', {
                params:{
                    page: this.table.options.page,
                    per_page: this.table.options.itemsPerPage,
                    name: this.table.search.name,
                    profile: this.table.search.profile,
                }
            }).then((response)=>{
                this.table.isLoading = false
                this.table.paginationData = response.data.meta
                this.table.items = response.data
                this.newSearch = false
                
            })
        },
    }
}
</script>
